import React from "react";
import { Helmet } from "react-helmet";

// Assets
import blogHeaderImage from "../../../assets/images/blog/blog-localYTsupport-asset.jpg";
import blogAsset from "../../../assets/images/blog/blog-YTLsupport-asset.jpg";

import "../blogTemplate.css";
import Footer from "../../Footer";

// Construct your blog data with an imported shareImage
const blogData = {
  title: "Local and YouTube Video Handling Supported",
  description: "Our platform now supports both local video uploads and YouTube video analysis, enabling seamless processing of content from multiple sources.",
  shareImage: blogHeaderImage,
};

function BlogHeader() {
  return (
    <div className="blog-header">
      <div className="blog-topic-pill">Product</div>
      <h1>{blogData.title}</h1>
      <p className="blog-info">November 25, 2024 • 5 min read</p>
    </div>
  );
}

function BlogBody() {
  return (
    <div className="blog-body">
      {/* Full-width share image */}
      <div className="blog-image-wrapper">
        <img 
          src={blogData.shareImage} 
          alt="Local and YouTube Video Handling Supported" 
          className="blog-picture" 
        />
      </div>

      {/* Introductory Section */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-text">
            <p>
              We are excited to announce that our platform now supports both <strong>local video uploads</strong> and <strong>YouTube video analysis</strong>. This new capability opens up a world of possibilities for managing and extracting insights from your video content, regardless of its source.
            </p>
          </div>
        </div>
      </div>

      {/* Local Video Support Section */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-section-title">
            <strong>Local Video Uploads</strong>
          </div>
          <div className="blog-text">
            <p>
              With our enhanced video handling features, you can now upload local videos directly to our platform. This allows you to analyze and process videos stored on your device, making it easier to work with proprietary or offline content.
            </p>
          </div>
        </div>
      </div>

      {/* YouTube Video Analysis Section */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-section-title">
            <strong>YouTube Video Analysis</strong>
          </div>
          <div className="blog-text">
            <p>
              In addition to local videos, our platform continues to offer comprehensive analysis for YouTube content. Whether your videos are public or unlisted, our AI-powered tools transform raw footage into structured, actionable insights.
            </p>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-text">
            <p>
              By supporting both local and YouTube videos, we provide a unified solution that caters to diverse content needs. This dual approach not only simplifies your workflow but also enables richer data extraction and improved content management across various platforms.
            </p>
          </div>
        </div>
      </div>

      <div className="blog-image-wrapper">
        <img src={blogAsset} alt="Placeholder content" className="blog-picture" />
      </div>

      {/* Call to Action Section */}
      <div className="body-content-block">
        <div className="blog-content-wrapper">
          <div className="blog-section-title">
            <strong>Experience the Difference Today</strong>
          </div>
          <div className="blog-text">
            <p>
              Ready to take your video content analysis to the next level? Explore our enhanced capabilities and see how our platform can streamline your workflow—whether you're handling local files or analyzing YouTube videos.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}


function BlogFooter() {
  return (
    <div>
      <footer className="blog-footer">
        <hr className="blog-footer-line" />
      </footer>
    </div>
  );
}

function blogYTandLocalSupport() {
  return (
    <div className="blog-template">
      <Helmet>
        <title>{blogData.title} | Bumpups.com</title>
        <meta name="description" content={blogData.description} />

        {/* Open Graph meta tags for sharing */}
        <meta property="og:title" content={blogData.title} />
        <meta property="og:description" content={blogData.description} />
        <meta property="og:image" content={blogData.shareImage} />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blogData.title} />
        <meta name="twitter:description" content={blogData.description} />
        <meta name="twitter:image" content={blogData.shareImage} />
      </Helmet>
      <BlogHeader />
      <BlogBody />
      <BlogFooter />
      <Footer />
    </div>
  );
}

export default blogYTandLocalSupport;
